











import Vue from 'vue'
export default Vue.extend({
  props: {
    upic: String,
    name: String,
    showEdit: Boolean,
    editPath: String,
    pathParams: {}
  }
})
